import BaseService from '../../base/base_service';
import IRedTigerService from './red_tiger_service_interface';

interface RedTigerServiceParams {
    RedTigerEnvironment: string;
}

export default class RedTigerService extends BaseService implements IRedTigerService {

    static CLASS = 'RedTigerService';

    private _initParams: RedTigerServiceParams = null;

    init(params: RedTigerServiceParams) {
        super.init(params);
        this._initParams = params;
    }

    public getRedTigerEnvironment(): string {
        return this._initParams.RedTigerEnvironment;
    }
}
